<template>
  <div class="liveCardIn">
    <p class="title">充值金额</p>
    <!--<van-field
        class="liveCardInInput"
        readonly disabled
        v-model="amount"
        type="number"
        input-align="center"
        @focus="selectChenge(10)"
    />-->
    <van-form
        class="code-form"
        ref="form"
        label-align="center"
    >
      <van-field
          class="liveCardInInput"
          v-model="amount"
          clearable
          type="number"
          maxLength="16"
          readonly disabled
          placeholder="充值金额"
          :rules="[
            {required: true, message: '必填'},
          ]"
      >
      </van-field>
    </van-form>

    <div class="num-btn-con">
      <!--<div class="item" :class="{selected: (selected===1)}" @click="selectChenge(1, 0.01)">
        <div class="num-title">0.01元</div>
      </div>-->
      <div class="item" :class="{selected: (selected===1)}" @click="selectChenge(1, 100)">
        <div class="num-title">100元</div>
      </div>
      <div class="item" :class="{selected: (selected===2)}" @click="selectChenge(2, 500)">
        <div class="num-title">500元</div>
      </div>
      <div class="item" :class="{selected: (selected===3)}" @click="selectChenge(3, 1000)">
        <div class="num-title">1000元</div>
      </div>
    </div>
    <div class="num-btn-con">
      <div class="item" :class="{selected: (selected===4)}" @click="selectChenge(4, 2000)">
        <div class="num-title">2000元</div>
      </div>
      <div class="item" :class="{selected: (selected===5)}" @click="selectChenge(5, 3000)">
        <div class="num-title">3000元</div>
      </div>
      <div class="item" :class="{selected: (selected===6)}" @click="selectChenge(6, 5000)">
        <div class="num-title">5000元</div>
      </div>
    </div>
    <div class="num-btn-con">
      <div class="item" :class="{selected: (selected===7)}" @click="selectChenge(7, 10000)">
        <div class="num-title">10000元</div>
      </div>
      <div class="item" :class="{selected: (selected===8)}" @click="selectChenge(8, 20000)">
        <div class="num-title">20000元</div>
      </div>
      <div class="item" :class="{selected: (selected===9)}" @click="selectChenge(9, 50000)">
        <div class="num-title">50000元</div>
      </div>
    </div>

    <div class="btn-con">
      <van-button class="coin-in-btn" size="large" type="warning" @click="showPass">{{ payBtnText }}</van-button>
      <div class="text">直播流量收费：1G=1.5元</div>
    </div>

    <ant-pay ref="antpay" :show="show" :showPayType="true" :paynum="paynum" :payData="payData" @close="onPayClose" @onPay="onPay" />

  </div>
</template>

<script>
import { liveCardOrder } from  '@/api/im/liveCard'
import { getPaySignInfo } from  '@/api/pay/payApi'
import AntPay from '@/components/antpay/antpay'
export default {
  components: {
    AntPay: AntPay,
  },
  data () {
    return {
      userOpenId: this.session('userOpenId'),
      show: false, // 支付框
      paynum: '￥100.00', // 需支付的金额
      amount: 100,//充值金额


      selected: 1,
      payBtnText: '立即充值',
      userInfo: this.session('userInfo'),

      payData: {},

    }
  },

  created() {
    this.payBtnText = this.paynum + ' 立即充值'
  },
  methods:{
    onClickLeft() {
      this.$router.go(-1)
    },

    selectChenge(type, num){
      switch (type){
        case 10:
          this.selected = type;
          break;
        default:
          this.amount = num;
          this.selected = type;
          break;
      }
    },

    //密码窗相关：
    showPass(){
      this.$refs['form'].validate().then(()=>{
        let req = {
          amount: this.amount, // 充值数量
          userOpenid: this.userOpenId,// 充值人 openId
          // remark: null,
          userType: 0, // 用户类型，0-个人
          beneficiaryUserOpenid: this.userOpenId, // 充值受益人的openId
          beneficiaryUserType: 0, // 订单受益人类型，0-个人
        };

        liveCardOrder(req).then(res=>{
          // console.log(res.data)
          this.payData = {
            amount: res.data.amount,
            orderNo: res.data.orderNo,
            orderType: 0, // 订单类型，0：直播点卡，1：商城购物 ,
            userOpenid: this.userOpenId,
            walletType: 0
          }
          this.show = true
        });
      })
    },
    onPayClose(){
      this.show = false
    },
    onPay(data){
      // console.log(data);
      if(data.payType==='blcPay'){
        getPaySignInfo(data).then(res=>{
          if(res.code===200){
            window.setTimeout(()=>{
              this.$router.go(-1)
            },1000)
            this.$toast('充值成功！')
            this.$refs.antpay.$close()
          }else {
            this.$refs.antpay.$close(res.message)
          }
        })
      }else if(data.payType==='wxJSAPI'){
        data.wxPayType = '直播流量充值'
        this.session('wxPay', data)
        this.$router.push({name: 'wxPay'})
      }
    }
  },
  watch: {
    amount(){
      if(this.amount){
        this.paynum = '￥'+ this.amount;
        this.payBtnText = this.paynum + ' 立即充值'
      }else {
        this.paynum = '￥0.00'
        this.payBtnText = '立即充值'
      }
    },
  },
}
</script>

<style scoped lang="less">
.liveCardIn{
  height: 100%;
  .title{
    text-align: center;
    color: #999;
    font-size: 15px;
    padding-top: 15px;
  }
  .coin-in-btn{
    background: linear-gradient(#ffbe12, #fe8901);
  }
  .num-btn-con{
    display: flex;
    justify-content: center;
    .item{
      width: 2.666rem;
      height: 1.333rem;
      border: 1px solid rgb(218,218,218);
      border-radius: 0.08rem;
      margin-top: .4rem;
      margin-right: .48rem;
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &:last-child{
        margin-right: 0;
      }
      .num-title{
        font-size: .48rem;
        color: rgb(43,43,43);
      }
      .num{
        font-size: .267rem;
        color: rgb(153,153,153);
      }
    }
    .selected{
      border-color: #FF7705;
      background-color: #FFEAD8;
      .num-title{
        color: rgb(225,127,1);
      }
      .num{
        color: rgb(225,127,1);
      }
    }
  }
  .btn-con{
    padding: 30px 15px 10px;
    .coin-in-btn{

    }
    .text{
      font-size: 12px;color: #999;text-align: center;line-height: 30px;
    }
  }
}
</style>
<style lang="less">
  .liveCardIn{
    .liveCardInInput{
      position: relative;
      input{
        font-size: 30px;
      }
    }
  }
</style>
